import api from "./api.js";

export default class AskApi {
  static async getList(params) {
    return await api.get(`ask`, params);
  }
  static async getById(askId, params) {
    return await api.get(`ask/${askId}`, params);
  }
  static async update(askId, data) {
    return await api.patch(`ask/${askId}`, data);
  }
  static async delete(data) {
    return await api.del(`ask`, data);
  }

  static async updateAnswer(askId, data) {
    return await api.patch(`ask/answer/${askId}`, data);
  }
}
